<template>
  <div>
  <div class="head" v-if="!_isMobile()">
    <img src="@/assets/images/0_img_logo_topb.png" alt="Logo" class="logo" />
    <div class="nav-tabs">
      <button :class="{ activeTab: activeName === '/' }" @click="selectTab('/')">{{ $t('header.home') }}</button>
      <button :class="{ activeTab: activeName === '/about' }" @click="selectTab('/about')">{{ $t('header.about') }}</button>
      <button :class="{ activeTab: activeName === '/technology' }" @click="selectTab('/technology')">{{ $t('header.technology') }}</button>
      <button :class="{ activeTab: activeName === '/oem' }" @click="selectTab('/oem')">{{ $t('header.oem') }}</button>
      <div
        class="dropdown"
        @mouseenter="showDropdown = true"
        @mouseleave="showDropdown = false"
      >
        <button
          :class="{ activeTab: isProductsActive }"
          @click="showDropdown = !showDropdown"
        >
          {{ $t('header.products') }}
        </button>
        <div class="dropdown-menu" v-if="showDropdown">
          <div class="dropdown-item" @click="selectProductsTab('/products')">Reduced Coenzyme Q10</div>
          <div class="dropdown-item" @click="selectProductsTab('/products_salacia')">Salacia Plus Tablets</div>
          <div class="dropdown-item" @click="selectProductsTab('/products_gmi')">SK Premium Gel</div>
        </div>
      </div>
      <button :class="{ activeTab: activeName === '/service' }" @click="selectTab('/service')">{{ $t('header.services') }}</button>
      <button :class="{ activeTab: activeName === '/contacts' }" @click="selectTab('/contacts')">{{ $t('header.contacts') }}</button>
    </div>
    <div class="lang-switch">
      <span :class="{ activeLang: $i18n.locale === 'ja' }" @click="changeLanguage('ja')">JP</span>
      <span class="divider">/</span>
      <span :class="{ activeLang: $i18n.locale === 'en' }" @click="changeLanguage('en')">EN</span>
    </div>
  </div>
    <div class="mb_head" v-if="_isMobile()">
      <div class="mb-logo" v-if="_isMobile()">
        <img src="@/assets/images/0_img_logo.png" alt="Logo" class="logo" />
      </div>
      <div class="menu" v-if="_isMobile()" @click="mb_drawer = !mb_drawer">≡</div>
    </div>
    <el-drawer
        :visible.sync="mb_drawer"
        size="330px"
        style="position: absolute;top: 55px"
        direction='rtl'>
      <div class="MobileMenu" v-if="_isMobile() && mb_drawer">
        <div class="nav-item" @click="toDetail('/mb_home')">{{ $t('header.home') }}</div>
        <div class="nav-item" @click="toDetail('/mb_about')">{{ $t('header.about') }}</div>
        <div class="nav-item" @click="toDetail('/mb_technology')">{{ $t('header.technology') }}</div>
        <div class="nav-item" @click="toDetail('/mb_oem')">{{ $t('header.oem') }}</div>
        <div class="nav-item" style="display: flex;justify-content: space-between">
          <span>{{ $t('header.services') }}</span>
          <i @click="showServicesList" style="margin-right: 15px" class="el-icon-arrow-down"></i>
        </div>
        <div class="serviceList" v-if="serviceListVisble">
          <div class="li" @click="toDetail('/mb_material')">{{ $t('header.rawMaterial') }}</div>
          <div class="li" @click="toDetail('/mb_flow')">{{ $t('header.productCustomization') }}</div>
          <div class="li" @click="toDetail('/mb_business')">{{ $t('header.importExport') }}</div>
        </div>
        <div class="nav-item" @click="toDetail('/mb_contacts')">{{ $t('header.contacts') }}</div>
        <div class="nav-item lang-switch-mb">
          <span :class="{ activeLang: $i18n.locale === 'ja' }" @click="changeLanguage('ja')">JP</span>
          <span class="divider">/</span>
          <span :class="{ activeLang: $i18n.locale === 'en' }" @click="changeLanguage('en')">EN</span>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import { Drawer } from 'element-ui';
export default {
  components: {
    'el-drawer': Drawer
  },
  name: "headView",
  data() {
    return {
      activeName: "/",
      showDropdown: false,
      tabName: "platform",
      mb_drawer: false,
      serviceListVisble: false,
    };
  },
  computed: {
    isProductsActive() {
      return this.activeName === "/products" || this.activeName === "/products_salacia" || this.activeName === "/products_gmi";
    }
  },  
  created() {
    const routeName = window.location.pathname.replace(/^\//, "");
    this.activeName = `/${routeName}`;
  },
  methods: {
    // 判断是否是手机端，如果是，返回true
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag instanceof Array
    },
    toDetail(url) {
      this.$router.push(url).catch(err => {
        console.log('输出报错',err)
      })
      this.mb_drawer = false

    },
    showServicesList() {
      this.serviceListVisble = !this.serviceListVisble
    },
    selectTab(tab) {
      this.showDropdown = false;
      if (this.$route.fullPath !== tab) {
        this.$router.push(tab).catch(err => {
          console.log('输出报错',err)
        })
        this.activeName = tab;
      }
    },
    selectProductsTab(tab) {
      this.showDropdown = false;
      this.selectTab(tab);
    },    
    handleClick(route) {
      if (this.$route.fullPath === `/${route}`) {
        return;
      }
      this.tabName = route;
      this.$router.push(`/${route}`);
      this.showDropdown = false;
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
  },
};
</script>
<style scoped lang="less">
.lang-switch {
  display: flex;
  align-items: center;
  margin-left: 20px;
  font-size: 16px;
  cursor: pointer;
  color: #fff;
  .activeLang {
    font-weight: bold;
    color: #409EFF; /* Adjust color as needed */
  }
  .divider {
    margin: 0 5px;
    color: #fff;
  }
}
.lang-switch-mb {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-size: 18px;
  .activeLang {
    font-weight: bold;
    color: #409EFF;
  }
  .divider {
    margin: 0 10px;
  }
}
.el-drawer__wrapper {
  /deep/ .el-drawer__header {
    display: none;
  }
}
.mb-logo {
  background-color: #fff;
  .logo {
    width: 120px;
    margin-top: 10px;
  }
}
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #422581;
  padding: 15px 20px;
}
.mb_head {
  background-color: #fff;
  display: flex;
  position: fixed;
  //height: 100%;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #ccc;
  .menu {
    font-size: 30px;
  }
}
.MobileMenu {
  z-index: 999;
  background-color: #fff;
  //position: fixed;
  //top: 55px;
  //right: 0;
  width: 330px;
  //box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.4);
  //height: 500px;
  .nav-item {
    font-size: 14px;
    padding: 15px 0 15px 20px;
    border-bottom: 1px solid #ccc;
  }
  .nav-item:last-child {
    //border-bottom: none;
  }
  .serviceList {
    display: block;
    height: 100%;
    .li {
      font-size: 14px;
      height: 50px !important;
      line-height: 50px;
      margin: 0 0  0 100px;
      border-bottom: 1px solid #ccc;
    }
  }
}

.nav-tabs {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-grow: 1;
  width: 60%;
  position: absolute;
  top: 20px;
  left: 20%;
  white-space: nowrap;
  overflow: visible; /* 改回 visible 保证下拉菜单能显示 */
  /*max-width: 800px; !* 你可以根据需要调整这个宽度 *!*/
}

/* 用一个内层包裹实现横向滚动，避免裁剪下拉菜单，但这需要改DOM结构。
   这里我们改为：缩小窗口时，不使用 overflow-x: auto（它会建立 BFC 导致下拉被裁）。
   我们允许 flex item 挤压，或者整体出现页面横向滚动，
   或者通过媒体查询在屏幕太小时改变布局。
   为了保证不换行且不裁剪下拉，最简单的做法是：
   移除 nav-tabs 的 overflow 限制，让浏览器自身出现横向滚动条（或者依靠其他容器）。
   如果必须要在 nav-tabs 区域滚动，我们需要改变 HTML 结构，将滚动层放在导航项里面。
   由于目前只要下拉菜单能出来，我们可以直接去掉 overflow-x: auto。
*/
.nav-tabs {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-around;
  flex-grow: 1;
  width: 60%;
  position: absolute;
  top: 20px;
  left: 20%;
  white-space: nowrap;
  overflow: visible;
}
/* 移除定制滚动条样式，因为不再在 nav-tabs 上滚动 */

.nav-tabs button {
  background: none;
  border: none;
  color: white;
  padding: 15px 25px;
  cursor: pointer;
  font-size: 18px;
  position: relative;
  white-space: nowrap;
  flex-shrink: 0;
}

.nav-tabs button.activeTab {
  font-weight: bold;
  border-bottom: 3px solid orange;
}

.dropdown {
  position: relative;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 220px;
  background: #fff;
  border: 1px solid #eee;
  box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}

.dropdown-item {
  padding: 12px 16px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-item:hover {
  background: #f5f5f5;
}
</style>
